import React from 'react';
import 'twin.macro';
import DemoImage from 'components/DemoImage';
import H1 from 'components/Typography/Headings/H1';

interface Props {
  title: string;
  subtitle?: string;
  imageUrl?: string;
  imageAlt?: string;
  cta?: React.ReactNode;
  children?: React.ReactNode;
}

export function EmptyModule({
  title,
  subtitle,
  imageUrl,
  imageAlt,
  children,
  cta,
}: Props) {
  return (
    <div tw="text-center mt-8">
      <H1 tw="text-neutral-moderate mb-2">{title}</H1>
      {subtitle && <p tw="text-muted mt-2">{subtitle}</p>}
      {children}
      {cta && <div tw="mt-4">{cta}</div>}
      {imageUrl && (
        <DemoImage
          imageUrl={imageUrl}
          alt={imageAlt}
          tw="my-12 max-w-5xl mx-auto"
        />
      )}
    </div>
  );
}
